import { formatDistanceStrict } from 'date-fns';
import { parseApiDate } from './apiDates';

const JUST_NOW_MS = 60_000;

/**
 * How long ago someone last signed in to this workspace, for admin tables.
 * `null`/`undefined` means they never have ("invited, never came").
 */
export function formatLastLogin(
  iso: string | null | undefined,
  now: Date = new Date()
): string {
  if (!iso) return 'Never';
  const when = parseApiDate(iso);
  if (Number.isNaN(when.getTime())) return '—';
  // A few seconds "in the future" is clock skew between server and browser.
  if (Math.abs(now.getTime() - when.getTime()) < JUST_NOW_MS || when > now) return 'Just now';
  return formatDistanceStrict(when, now, { addSuffix: true });
}

/** Exact moment for a hover tooltip next to {@link formatLastLogin}. */
export function lastLoginTitle(iso: string | null | undefined): string {
  if (!iso) return 'Has not signed in yet';
  const when = parseApiDate(iso);
  if (Number.isNaN(when.getTime())) return '';
  return when.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
